import { tw } from '@/utils/tw';
import BaseBylineTheme from 'base/components/Byline/theme';

const { Image } = BaseBylineTheme;

const Byline = tw.theme({
  extend: BaseBylineTheme,
  slots: {
    author: `text-gray-700`,
  },
});

export default Object.assign(Byline, { Image });
